import { render, staticRenderFns } from "./EventAttendanceBoard.vue?vue&type=template&id=657282e3&scoped=true"
import script from "./EventAttendanceBoard.vue?vue&type=script&lang=js"
export * from "./EventAttendanceBoard.vue?vue&type=script&lang=js"
import style0 from "./EventAttendanceBoard.vue?vue&type=style&index=0&id=657282e3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657282e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('657282e3')) {
      api.createRecord('657282e3', component.options)
    } else {
      api.reload('657282e3', component.options)
    }
    module.hot.accept("./EventAttendanceBoard.vue?vue&type=template&id=657282e3&scoped=true", function () {
      api.rerender('657282e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Menus/components/EventAttendanceBoard.vue"
export default component.exports